const notifications = [
  {
    id: 1,
    notification:
      "Mollit ipsum pariatur proident velit. Anim magna dolore cupidatat do dolore excepteur aliquip aliquip consectetur consectetur. Occaecat cillum ea quis ipsum consequat magna ullamco. Ut nulla anim aliquip dolore eu consequat ea.",
    isRendered: false,
  },
  {
    id: 2,
    notification:
      "Voluptate fugiat irure proident mollit ullamco officia excepteur reprehenderit pariatur sit dolore laborum eiusmod. Amet ut enim anim consectetur id duis aute mollit aliquip. Amet mollit aliqua commodo exercitation pariatur velit sint ut eu nostrud Lorem aute. Non nulla ut aute mollit deserunt deserunt occaecat quis eu consequat do sunt proident. Ut amet Lorem fugiat labore voluptate consectetur consequat officia non Lorem veniam culpa tempor do. Mollit velit enim proident ex officia est incididunt non nisi dolore consectetur.",
    isRendered: true,
  },
  {
    id: 3,
    notification:
      "Velit elit qui quis cillum. Sit et ullamco dolor duis culpa. Sit labore magna dolor labore enim ipsum laboris esse cillum.",
    isRendered: false,
  },
];

export default notifications